'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class wpActivityModel extends ngDepModel
{
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	getValue(name){
		switch(name){
			case 'completion_status':
				return this.getClassifValue(name, 'completion_status');
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}	
}
